import { Box, Heading, useColorMode, Image } from "@chakra-ui/react";
import axios from "axios";
import httpStatus from "http-status";
import React from "react";
import NotificationsRightContent from "../components/dashboard/NotificationsRightContent";
import SecondTableDashboard from "../components/dashboard/SecondTableDashboard";
import LayoutTwo from "../components/layouts/LayoutTwo";
import TicketsTable from "../components/tickets/TicketsTable";

export default function Dashboard() {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <>
      <LayoutTwo>
        <Box className="userlist_page">
          <Box className="usr_list_cntnr">
            <Heading as="h2" className="def_head_dbrd">
              Dashboard
            </Heading>
            <Box className="dahboardgrid">
              <Box className="user_cntnt_box flex75">
                {colorMode === "light" ? (
                  <Image
                    src="/img/user_list_top_img.png"
                    alt=""
                    className="user_list_top_img"
                  />
                ) : (
                  <Image
                    src="/img/user_list_top_img_dark.png"
                    alt=""
                    className="user_list_top_img"
                  />
                )}
                {colorMode === "light" ? (
                  <Image
                    src="/img/user_list_btm_img.png"
                    alt=""
                    className="user_list_btm_img"
                  />
                ) : (
                  <Image
                    src="/img/user_list_btm_img_dark.png"
                    alt=""
                    className="user_list_btm_img"
                  />
                )}
                <Box className="user_cntr_line_bg" />
                {/* <Box className="user_cntr_line_bg" />
                <Box className="create_user_prnt_raw">
                  <Box>
                    <NewUserModal />
                  </Box>
                </Box> */}
                <Box className="flex_full_boxs">
                  {/* <UserListTable /> */}
                  <Box>
                    <TicketsTable isPagination={false} pagination={5} />
                    <SecondTableDashboard />
                  </Box>
                </Box>
              </Box>
              <Box className="flex25">
                <Box className="main_rightbx">
                  {colorMode === "light" ? (
                    <Image
                      src="/img/ntfctn_tp.png"
                      alt=""
                      className="ntfctn_tp"
                    />
                  ) : (
                    <Image
                      src="/img/ntfctn_tp_dark.png"
                      alt=""
                      className="ntfctn_tp"
                    />
                  )}
                  {colorMode === "light" ? (
                    <Image
                      src="/img/ntfctn_btm.png"
                      alt=""
                      className="ntfctn_btm"
                    />
                  ) : (
                    <Image
                      src="/img/ntfctn_btm_dark.png"
                      alt=""
                      className="ntfctn_btm"
                    />
                  )}
                  <Box className="ntfctn_mddl" />
                  <Box className="right_content_main">
                    <NotificationsRightContent />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          {/* <Image src="/img/user_list_top_sdw_circle_img.png" alt="" className="user_list_top_sdw_circle_img" /> */}
        </Box>
      </LayoutTwo>
    </>
  );
}

